import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexEmployees from "./companyEmployees/IndexEmployees";
// import CreateNewEmployee from "./companyEmployees/components/CreateNewEmployee";

import IndexAddresses from "./addresses/IndexAddresses";
import IndexContacts from "./contacts/IndexContacts";
import IndexCertification from "./certification/IndexCertification";
import IndexEducations from "./educations/IndexEducations";
import IndexExperience from './experiences/IndexExperience';
import IndexRelatives from "./relatives/IndexRelatives";
import IndexBanks from "./bank/IndexBanks";
import IndexAssets from "./assets/IndexAssets";
import IndexSalaries from "./salleries/IndexSalaries";
import AddEmployee from "./companyEmployees/components/AddEmployee";
import { useSelector } from "react-redux";
import IndexQuickEmployeeInfo from "./quickEmployeeInfo/IndexQuickEmployeeInfo";
import EmployeeProfilePage from "./companyEmployees/components/EmployeeProfilePage";
import { guardElement } from "@comps/components";


const EmployeeModules = () => {
      const authUser = useSelector((state) => state.auth.authUser);
      return (
            <Routes>
                  <Route path="" element={ guardElement(<IndexEmployees modkey="employeeIndex" />, "employeeIndex") } />
                  <Route path="company" element={ guardElement(<IndexEmployees module="employees" filters='' modkey="employeeIndex" />, "employeeIndex") } />
                  <Route path="/employees" element={ guardElement(<IndexEmployees module="employees" filters='' modkey="employeeIndex" />, "employeeIndex") } />
                  <Route path="subordinates" element={ guardElement(<IndexEmployees module="subordinates" filters={ `subordinate_|${authUser.employment_id}` } modkey="subordinateEmployees" />, "subordinateEmployees") } />
                  <Route path="employments/index" element={ guardElement(<IndexEmployees module="employees" filters='' modkey="employeeIndex" />, "employeeIndex") } />
                  {/* <Route path="create" element={ <CreateNewEmployee /> } /> */ }

                  <Route path="addresses" element={ guardElement(<IndexAddresses modkey="employeeAddress" />, "employeeAddress") } />
                  <Route path="contacts" element={ guardElement(<IndexContacts modkey="employeeContact" />, "employeeContact") } />
                  <Route path="certifications" element={ guardElement(<IndexCertification modkey="employeeCertification" />, "employeeCertification") } />
                  <Route path="educations" element={ guardElement(<IndexEducations modkey="employeeEducation" />, "employeeEducation") } />
                  <Route path="experiences" element={ guardElement(<IndexExperience modkey="employeeExperience" />, "employeeExperience") } />
                  <Route path="relatives" element={ guardElement(<IndexRelatives modkey="employeeRelative" />, "employeeRelative") } />
                  <Route path="banks" element={ guardElement(<IndexBanks modkey="employeeBank" />, "employeeBank") } />
                  <Route path="employments/assets" element={ guardElement(<IndexAssets modkey="employmentAsset" />, "employmentAsset") } />
                  <Route path="employments/salaries" element={ guardElement(<IndexSalaries modkey="employmentSalary" />, "employmentSalary") } />
                  <Route path="add-employee" element={ guardElement(<AddEmployee modkey="employeeIndex" />, "employeeIndex", "create") } />
                  <Route path="quickEmployeeInfo" element={ guardElement(<IndexQuickEmployeeInfo modkey="quickEmployeeInfo" />, "quickEmployeeInfo") } />
                  <Route path="profile/:employmentId/:tab?" element={ guardElement(<EmployeeProfilePage />, "companyEmployees") } />
            </Routes>
      );
}

export default EmployeeModules;
